import { render } from "./SensorIcon.vue?vue&type=template&id=6d17a828&ts=true"
import script from "./SensorIcon.vue?vue&type=script&lang=ts"
export * from "./SensorIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__